<template>
  <div class="mb-4">
    <div class="sample-database-detail dashboard-card">
      <div class="sample-database-detail-body cs-scroll-style">
        <b-row>
          <b-col cols="12" class="mb-4">
            <div class="title-header">
              <h5>{{ $tI('Genetic Profile title') }}</h5>
            </div>
            <div class="p-1">
              <h5 v-if="!farmerHgResultList">{{ $tI('Unavailable') }}</h5>
              <template v-else>
                <div v-for="itemAncestry in farmerHgResultList.resultList" :key="itemAncestry.resultName" class="farmer-hgs mb-1">
                  <span class="label">
                    {{ $tPop(itemAncestry.resultName, 'title',  itemAncestry.resultName.replaceAll('*', ' ')) }} :
                  </span>
                  <span class="percent"><b>{{ itemAncestry.resultValue.toFixed(1) }}%</b></span>
                </div>
              </template>
            </div>
          </b-col>
          <b-col cols="12">
            <div class="title-header">
              <h5>{{ 'Genetically Closest Populations' }}</h5>
            </div>
            <div class="dist-table-container">
              <div class="dist-tab"
                v-for="(tab) in $store.state.sampleDatabase.distanceTypes" :key="tab" 
                :class="{ 'active': tab === $store.state.sampleDatabase.distanceType }"
                @click="$store.state.sampleDatabase.distanceType = tab"
              >
                {{ $tI(tab) }}
              </div>
            </div>
            <div class="distance-container">
              <table class="table table-striped distance-table">
                <thead class="table-light">
                  <tr>
                    <th scope="col">{{ $tI('Distance title') }}</th>
                    <th scope="col">{{ $tI('Population title') }}</th>
                  </tr>
                </thead>
                <tbody v-show="$store.state.sampleDatabase.distanceType === 'Modern'">
                  <tr v-for="distanceItem in distanceList" :key="distanceItem.title">
                    <td><span class="td-size" :style="{ color: distanceItem.gradHSL }"> {{ distanceItem.distance }}</span></td>
                    <td>{{$t(distanceItem.title.replaceAll('*', ' '))}}</td>
                  </tr>
                </tbody>
                <tbody v-show="$store.state.sampleDatabase.distanceType === 'Ancient'">
                  <tr v-for="distanceItem in distanceAncientList" :key="distanceItem.title">
                    <td><span class="td-size" :style="{ color: distanceItem.gradHSL }"> {{ distanceItem.distance }}</span></td>
                    <td>{{$t(distanceItem.title.replaceAll('*', ' '))}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
  },
  props: {
  },
  data() {
    return {
    }
  },
  methods: {
    back() {
      this.$store.state.modernDatabase.sampleDetail = null
    },
  },
  computed: {
    distanceList() {
      return this.$store.state.sampleDatabase.calculatedDistance;
    },
    distanceAncientList() {
      return this.$store.state.sampleDatabase.calculatedDistanceAncient;
    },
    farmerHgResultList() {
      return this.$store.state.sampleDatabase.calculatedFarmerHgResult;
    },
  },
  mounted() {
  },
};
</script>

<style lang="scss" scoped>
.sample-database-detail {
  background-color: var(--white-100);
}
</style>
